import {Component, Injector} from '@angular/core';
import {BlogCategoryState, Store as BlogCategoryStore} from './state/store';
import {BlogCategory} from './state/model';
import {BlogCategoryService as BlogCategoryService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {BlogCategoryQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class BlogCategoryDetailComponent extends EntityDetailComponent<BlogCategory, BlogCategoryState, BlogCategoryStore> {

  constructor(
    public injector: Injector,
    service: BlogCategoryService,
    protected query: BlogCategoryQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
